<template>
  <v-row align="center" no-gutters>
    <v-col>{{title}}</v-col>
    <v-col class="text-right">
      <v-btn text large color="primary" @click="$emit('close')">
        <v-icon left>close</v-icon>close
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ADialogTitle",
  props: ["title"]
};
</script>